import { createClient } from "./createClient";
import { createSimulations } from "./createSimulations";
import { getComplements } from "./getComplements";
import { getFiles } from "./getFiles";
import { getOperations } from "./getOperations";
import { postTransaction } from "./postTransaction";
import { uploadFiles } from "./uploadFiles";

export const crefisaService = {
  createClient,
  createSimulations,
  getComplements,
  getFiles,
  getOperations,
  postTransaction,
  uploadFiles,
};
